import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { faCoins } from '@fortawesome/free-solid-svg-icons';

import EntityTable from "../Listing/EntityTable";
import Accordion from "../NavTab/Accordion";

import usePaymentColumns from "../../hooks/paymentColumns";
import { formatAmount } from "../Order/paymentColumns";
import PaymentMethodBadge from "../Order/PaymentMethodBadge";
import { formatRelativeDate } from "../../utils/FormatDate";
import { NavLink } from "react-router-dom";
import { API_BASE_URL } from '../../api';

const PatientPayments = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const columns = usePaymentColumns({
    excludeColumns: ["patientId"]
  });

  // Card-view design for this listing (Table's enableCardView feature, forced on mobile)
  // — reuses the actions column's own dropdown so both views offer identical actions.
  const paymentsActionsColumn = columns.find((c) => c.accessor === "actions");
  const renderPaymentCard = (row) => (
    <div className="card h-100 shadow-sm">
      <div className="card-body d-flex flex-column" style={{ padding: 14, gap: 6 }}>
        <NavLink to={`/payments/${row.id}`} style={{ fontSize: 13.5, fontWeight: 600, color: "#111827" }}>
          {row.paymentNumber}
        </NavLink>
        <span style={{ fontSize: 11.5, color: "#9ca3af" }}>{formatRelativeDate(row.paymentCreatedAt)}</span>

        {row.paymentMethod && (
          <div style={{ alignSelf: "flex-start" }}><PaymentMethodBadge method={row.paymentMethod} /></div>
        )}

        <div className="d-flex align-items-center justify-content-between" style={{ marginTop: "auto", paddingTop: 6 }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: "#059669" }}>{formatAmount(row.amount)}</span>
            <span style={{ fontSize: 10.5, color: "#9ca3af", fontWeight: 500 }}>dhs</span>
          </div>
          {paymentsActionsColumn?.Cell(row)}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Accordion
        id="patientPayments"
        parent="patient_information_container"
        title={t('Payments')}
        icon={faCoins}
        flush
      >
        <EntityTable
          endpoint={`${API_BASE_URL}/api/v1/payments`}
          columns={columns}
          extraParams={{
            patientId: id
          }}
          defaultSort="id"
          defaultDirection="desc"
          pageSize={20}
          emptyMessage="Aucun paiement"
          searchable={true}
          multiSelect={false}
          enableCardView={true}
          renderCard={renderPaymentCard}
        />
      </Accordion>
    </>
  );
};

export default PatientPayments;